// 计费单

import { HttpCapacityList, HttpGetAreaList, HttpDeleteCapacityOne } from '@/service/report';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import comIndex from './update'
export default {
    mixins: [TableList],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            areaList:[]
        };
    },
    created(){
        HttpGetAreaList().then(res=>{
            this.areaList = res.data.map(item=>{
                return {
                    label:item.areaName,
                    value:item.id
                }
            })
        })
    },
    methods: {
        ajaxRequest: HttpCapacityList,
        interceptRequest(params) {
            return params
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/capacityPredict/export", this.formData, 'download')
                    break;
                case 'exportall':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/capacityPredict/exportAll", {}, 'download')
                    break;
                case 'delete':
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        desc: this.$t('fbb.localemanage.confirm_delete',{defaultValue:'删除后不可恢复，是否确认删除？'}),
                        ajaxRequest: HttpDeleteCapacityOne
                    };
                    break;
                case 'add':
                    this.operate = {
                        title: this.$t( 'erp.product.new_add', { defaultValue: '添加' }),
                        show:true,
                        width:560,
                        component: "comIndex",
                        type:'add',
                        showFooter:false,
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show:true,
                        width:560,
                        component: "comIndex",
                        type:'edit',
                        activeid:params,
                        showFooter:false,
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        showDesc: false,
                        component: "compUpload",
                        name: "multipartFile",
                        width:450,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/capacityPredict/batchImport",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/capacityPredict/importTemplate', {}, 'download')
                        },
                    };
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id, type } = row;
            return [{
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            },{
                label: '删除',
                show: true,
                params: id,
                operate: 'delete'
            },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList', 'getBillcusWareList']),
        ...mapGetters('common', ['getOnshelfStatue']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导入",
                    operate: "import",
                    theme: "success",
                },
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
                {
                    name: "导出所有",
                    operate: "exportall",
                    theme: "warning",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "区域",
                    key: 'EQ_areaId',
                    tag: 'vSelect',
                    show: true,
                    options: this.areaList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "月份",
                    tag: 'vDatepicker',
                    key: 'EQ_month',
                    show: true,
                    props: {
                        format: 'yyyy-mm',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: '月份',
                    key:'month'
                },
                {
                    title: '区域',
                    key:'areaName'
                },
                {
                    title: '预计入库(cbm)',
                    key: 'predictIn',
                },
                {
                    title: '预计出库(cbm)',
                    key: 'predictOut',
                },
                {
                    title: '更新时间',
                    key: 'updatedAt',
                },
                
            ];
        },
    },
};




